var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePcLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1102,
    height: 2,
    viewBox: "0 0 1102 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1101 1L1 1",
    stroke: "url(#paint0_linear_172_4606)",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_4606",
    x1: 1157.54,
    y1: 0.999976,
    x2: 0.346276,
    y2: 0.430821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522869,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePcLine);
export default __webpack_public_path__ + "static/media/HomePCLine.208ae75b78617c3e31e1952d7414face.svg";
export { ForwardRef as ReactComponent };